import {
	AppBar,
	Dialog,
	DialogActionsProps,
	DialogContent,
	DialogContentProps,
	DialogTitle,
	IconButton,
	IconButtonProps,
	useTheme,
} from '@mui/material';
import React from 'react';

import Icon from 'presentation/icons';

import {Loading} from '../Loading/Loading';
import {Footer, HeaderContainer, StyledCloseButton, StyledIcon} from './styles';
import {ModalHeaderProps, ModalRootProps} from './types';

function ModalRoot({
	isLoading,
	children,
	onClose,
	open,
	customMaxWidth,
	customMaxHeight,
	...dialogProps
}: ModalRootProps) {
	return (
		<Dialog
			onClose={onClose}
			open={open}
			slotProps={{
				paper: {
					style: {
						maxWidth: customMaxWidth || 420,
						borderRadius: 8,
						margin: 16,
						maxHeight: customMaxHeight,
					},
				},
			}}
			{...dialogProps}>
			{isLoading ? <Loading minHeight="100px" /> : children}
		</Dialog>
	);
}

function ModalHeader({
	title,
	onClose,
	closeBtnColor,
	disableClose,
	closeBtnDataTagId,
	modalDataTagId,
	...appBarProps
}: ModalHeaderProps) {
	const theme = useTheme();

	return (
		<AppBar
			elevation={0}
			{...appBarProps}
			position="relative"
			sx={{
				backgroundColor: theme.palette.other.planColor || theme.palette.primary.main,
				...appBarProps.sx,
			}}>
			<HeaderContainer disableGutters data-tag-id={modalDataTagId}>
				<DialogTitle sx={{p: 0, maxWidth: 'calc(100% - 32px)'}} variant="h6">
					{title}
				</DialogTitle>
				{!disableClose ? (
					<IconButton
						onClick={onClose}
						aria-label="close"
						color="inherit"
						data-tag-id={closeBtnDataTagId}>
						<Icon
							name="close-filled"
							color={closeBtnColor || theme.palette.other.closeIcon}
						/>
					</IconButton>
				) : null}
			</HeaderContainer>
		</AppBar>
	);
}

function ModalCloseButton(iconButtonProps: IconButtonProps) {
	return (
		<StyledCloseButton aria-label="close" size="large" {...iconButtonProps}>
			<StyledIcon name="close-filled" />
		</StyledCloseButton>
	);
}

function ModalContent({children, ...dialogContentProps}: DialogContentProps) {
	return <DialogContent {...dialogContentProps}>{children}</DialogContent>;
}

function ModalFooter({children, ...dialogActionsProps}: DialogActionsProps) {
	return <Footer {...dialogActionsProps}>{children}</Footer>;
}

export const Modal = {
	CloseButton: ModalCloseButton,
	Header: ModalHeader,
	Content: ModalContent,
	Footer: ModalFooter,
	Root: ModalRoot,
};
